import React, { Component } from 'react'
import img1 from '../../static/images/download-logo.png'
import product3 from '../../static/images/product-3.png'

import about2 from '../../static/images/pos-banner-top.png'
import about4 from '../../static/images/about-4.png'


import './index.less';
class downloadCenter extends Component {
    state = {
        iframeHeight: 600,
        customerList: [
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
        ],
        partnerList: [
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
        ],
    }
    onEvents() { }
    componentDidMount() {
        this._onAffiliateIframeMessage = (e) => {
            const d = e.data
            if (!d || d.source !== 'download-iframe' || typeof d.height !== 'number') return
            if (d.height < 200) return
            this.setState({ iframeHeight: d.height })
        }
        window.addEventListener('message', this._onAffiliateIframeMessage)
    }

    componentWillUnmount() {
        window.removeEventListener('message', this._onAffiliateIframeMessage)
    }

    syncIframeHeightFromContent = (iframe) => {
        if (!iframe) return
        try {
            const doc = iframe.contentDocument || iframe.contentWindow.document
            const h = Math.max(
                doc.documentElement.scrollHeight,
                doc.body.scrollHeight,
                doc.documentElement.offsetHeight,
                doc.body.offsetHeight
            )
            if (h > 200) {
                this.setState({ iframeHeight: h })
            }
        } catch (err) {
            // cross-origin: rely on postMessage from affiliate.html
        }
    }
    render() {
        const { iframeHeight } = this.state
        return (
             <div style={{ width: '100%' }}>
                <iframe
                    title="download-static"
                    src={`${process.env.PUBLIC_URL}/static/downloadCenter/downloadCenter.html`}
                    style={{ width: '100%', height: iframeHeight, border: 'none', display: 'block', overflow: 'hidden' }}
                    onLoad={(e) => this.syncIframeHeightFromContent(e.target)}
                />
            </div>
            // <div className="product_container download-center-page">
                


            //     <div className="common-block-home">
            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-left">
            //                     <img className="member-img-style" src={img1} alt="" />
            //                 </div>
            //                 <div className="advantage-detail-right">
            //                     <div className="advantage-detail-left-title">悦喵AI-智慧门店云POS系统</div>
            //                     <div className="advantage-detail-left-tips">多门店多场景多业态是的一站式门店数字化大SAAS系统，赋能商家及合作伙伴，省钱又赚钱！</div>
            //                 </div>
                            
            //             </div>

            //         </div>
                   
                    

            //     </div>
               
            //     <div className="common-block-home version-download-block">
            //         <div className="version-content">
            //             <div className="version-detail-content">
            //                 <div className="version-detail-left">
            //                     <div className="version-detail-title">PC桌面收银</div>
            //                     <div className="version-detail-tips">
            //                         <div className="common-tips-style color-style">WINDOWS</div>
            //                         <div className="common-tips-style">支持触摸屏</div>
            //                     </div>
            //                 </div>
            //                 <div className="version-detail-right">
            //                     <img className="version-img" src={about2} alt="" />
            //                 </div>
            //             </div>
                        
            //             <div className="version-tips">使用于WINXP以上系统。支持零售、生鲜、超市等行业</div>
            //             <div className="version-tips">适用于POS一体机、PC触摸屏、家用电脑、笔记本等。</div>
            //             <div className="version-content-bottom">
            //                 <div className="version-download-btn">下载通用版本</div>
            //             </div>
            //         </div>
            //         <div className="version-content">
            //             <div className="version-detail-content">
            //                 <div className="version-detail-left">
            //                     <div className="version-detail-title">平板/桌面收银</div>
            //                     <div className="version-detail-tips">
            //                         <div className="common-tips-style color-style">安卓</div>
            //                         <div className="common-tips-style">ios</div>
            //                     </div>
            //                 </div>
            //                 <div className="version-detail-right">
            //                     <img className="version-img" src={about2} alt="" />
            //                 </div>
            //             </div>

            //             <div className="version-tips">适用于安卓5.0版本及以上各类安卓平板及桌面收银一体机</div>
            //             <div className="version-tips"></div>
            //             <div className="version-content-bottom">
            //                 <div className="version-download-btn">下载零售版本</div>
            //                 <div className="version-download-btn">下载餐饮版本</div>
            //             </div>
            //         </div>
            //         <div className="version-content">
            //             <div className="version-detail-content">
            //                 <div className="version-detail-left">
            //                     <div className="version-detail-title">手机/手持收银</div>
            //                     <div className="version-detail-tips">
            //                         <div className="common-tips-style color-style">安卓</div>
            //                         <div className="common-tips-style">ios</div>
            //                     </div>
            //                 </div>
            //                 <div className="version-detail-right">
            //                     <img className="version-img" src={about2} alt="" />
            //                 </div>
            //             </div>

            //             <div className="version-tips">适用于安卓5.0版本及以上安卓手机、手持移动设备等。</div>
            //             <div className="version-tips">ios版本正在开发，敬请期待</div>
            //             <div className="version-content-bottom">
            //                 <div className="version-download-btn">下载零售版本</div>
            //                 <div className="version-download-btn">下载餐饮版本</div>
            //             </div>
            //         </div>
            //         <div className="version-content">
            //             <div className="version-detail-content">
            //                 <div className="version-detail-left">
            //                     <div className="version-detail-title">小程序助手</div>
            //                     <div className="version-detail-tips">
            //                         <div className="common-tips-style">小程序</div>
            //                     </div>
            //                 </div>
            //                 <div className="version-detail-right">
            //                     <img className="version-img" src={about2} alt="" />
            //                 </div>
            //             </div>

            //             <div className="version-tips">博弈收银微信小程序，拥有基础收银、预约、开单等门店端实用功能。</div>
            //             <div className="version-tips"></div>
            //             <div className="version-content-bottom">
            //                 <div className="version-download-btn">扫码体验-零售</div>
            //             </div>
            //         </div>
            //     </div>


               
            // </div >
        )
    }
}


export default downloadCenter